/**
 * StandOut WordPress Theme
 * Theme-wide functionality initialization
 *
 * @package StandOut
 * @since 2.0.0
 */
import { onDomReady } from "@utils/dom-ready";
onDomReady(() => {
    // Navigation (conditional loading)
    const navigation = document.querySelector(".main-navigation");
    const scrollProgress = document.querySelector(".scroll-progress-container");
    if (navigation) {
        import("./navigation")
            .then(({ ThemeNavigation }) => {
            new ThemeNavigation();
        })
            .catch((error) => {
            console.error("Failed to load navigation module:", error);
        });
        // Fade in navigation and scroll progress (CSS transition handles the 2s duration)
        navigation.style.opacity = "1";
        if (scrollProgress) {
            scrollProgress.style.opacity = "1";
        }
    }
    // Year select on birth date fields (conditional loading)
    if (document.querySelector("input[data-type-datepicker][name$='birthdate']")) {
        import("./birthdate-picker")
            .then(({ initBirthdatePicker }) => {
            initBirthdatePicker();
        })
            .catch((error) => {
            console.error("Failed to load birthdate picker module:", error);
        });
    }
});
